import React, { useState } from 'react';
import { Card, CardContent, TextField, Button, Typography, Box } from '@mui/material';
import QuizLayout from './QuizLayout';
import { ADMIN_PASS_KEY } from './quizLogic';

// Admin passcode gating is currently disabled by default. The prompt/enforcement
// code below is kept dormant (not deleted) so it can be re-enabled later by
// flipping this flag to true.
const GATING_ENABLED = false;

export default function AdminGate({ children }) {
  const [pass, setPass] = useState(localStorage.getItem(ADMIN_PASS_KEY) || '');
  const [entry, setEntry] = useState('');

  if (!GATING_ENABLED) {
    return children(localStorage.getItem(ADMIN_PASS_KEY) || '');
  }

  if (pass) {
    return (
      <>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2 }}>
          <Button size="small" onClick={() => { localStorage.removeItem(ADMIN_PASS_KEY); setPass(''); }}>
            Sign out of admin
          </Button>
        </Box>
        {children(pass)}
      </>
    );
  }

  const submit = () => {
    const value = entry.trim();
    if (!value) return;
    localStorage.setItem(ADMIN_PASS_KEY, value);
    setPass(value);
  };

  return (
    <QuizLayout title="Quiz Admin">
      <Card><CardContent>
        <Typography sx={{ mb: 2 }}>Enter the admin passcode to manage quizzes.</Typography>
        <TextField
          fullWidth type="password" label="Admin passcode" value={entry}
          onChange={(e) => setEntry(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
          inputProps={{ 'data-testid': 'admin-pass-input' }} sx={{ mb: 2 }}
        />
        <Button variant="contained" onClick={submit} data-testid="admin-pass-submit">Unlock</Button>
      </CardContent></Card>
    </QuizLayout>
  );
}
